import { FormattedMessage } from 'react-intl';
import { useSiteConfig } from 'contexts/SiteConfigProvider';
import { useParams } from 'react-router-dom';

function ProductPrice({ price, quantity }: { price: number, quantity?: number }) {
    const hasPrice = price && price > 0;
    const { getCurrencyCode } = useSiteConfig();
    const urlParams = useParams(),
        locale = (urlParams as any).locale;
    const getFormatPrice = () => {
        if (!hasPrice) return '';
        const total = quantity ? (price * quantity) : price;
        return `${total.toLocaleString(locale, { maximumFractionDigits: 2, minimumFractionDigits: 2 })} ${getCurrencyCode()}`;
    };
  
    return hasPrice ? <span>{getFormatPrice()}</span> : <FormattedMessage id="ml_114747" defaultMessage="X - Login to see price" />;
}

export default ProductPrice;